import React from 'react';

import UserReviewStars from '../userreviewstars/UserReviewStars';

//swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import 'swiper/components/pagination/pagination.scss';
SwiperCore.use([Autoplay]);

import GetStartedImage from 'assets/images/pages/get-started/pharmuni.svg';
import StarsImage from 'assets/images/pages/get-started/stars.svg';
import Testimonial1Image from 'assets/images/pages/get-started/testimonial1.webp';
import Testimonial2Image from 'assets/images/pages/get-started/testimonial2.webp';
import Testimonial3Image from 'assets/images/pages/get-started/testimonial3.webp';

import classes from './RegisterCarousel.module.scss';


const RegisterCarousel = () => {
    const [activeIndex, setActiveIndex] = React.useState(0);
    const testimonials = [
        {
            name: 'John Doe',
            text: 'Pharmuni does extensive work that supports professionals in the field to further deepen their professional skills, regardless of their location. By sharing useful and up-to-date materials through courses and social networks, professionals can find answers to their questions. And, of course, about the feedback, which is really inspiring.',
            image: Testimonial3Image,
            plathform: 'Trustpilot',
        },
        {
            name: 'Enos Kudakwashe Tete',
            text: 'One of the best choices I have ever made in my career is to enroll in PharmUni online courses. I have learnt priceless information and abilities from PharmUni that have significantly aided in my professional development in the pharmaceutical industry. I heartily endorse their courses to anyone hoping to progress in the pharmaceutical field.',
            image: Testimonial1Image,
            plathform: 'Pharmuni',
        },
        {
            name: 'Zhuo Yu Khaw',
            text: 'The courses are great introductory courses for topics that I am interested in exploring but unsure where to start. These courses provided me an overall information on the topics and allow me to have introductory knowledge to better understand the concept. The videos are short and straightforward, which is great for working adults like me...',
            image: Testimonial2Image,
            plathform: 'Pharmuni',
        },
    ];
    return (
        <div className={`${classes['testimonials-wrapper']} d-flex flex-column align-items-center justify-content-center`}>
            <GetStartedImage />
            <h2>Your Guided Path to Learning, Community, and a Career in Pharma Starts Here!</h2>
            <div className={`${classes['trust-score']} d-flex align-items-center justify-content-center gap-5 w-100`}>
                <div>
                    {/* <h5>TrustPilot</h5>
                    <StarsImage />
                    <div>Trust Score 4.5</div> */}
                    <UserReviewStars />
                </div>
                <div>
                    <span>96%</span>
                    <div className='mt-2'>Course Satisfaction</div>
                </div>
            </div>

            <Swiper
                direction="vertical"
                slidesPerView={1.5}
                centeredSlides={true}
                loop={true}
                autoplay={{ delay: 4000, disableOnInteraction: false }}
                onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
                style={{ height: '350px', marginTop: '40px' }}
                spaceBetween={60}
            >
                {testimonials.map((testimonial, idx) => (
                    <SwiperSlide key={idx}>
                        <div className={classes['testimonial-slide']}>
                            <p>"{testimonial.text}"</p>
                            <div className={classes['testimonial-image']}>
                                <img src={testimonial.image.src} alt={testimonial.name} />
                                <div>
                                    {testimonial.name}
                                    <div className={classes['testimonial-plathform']}>{testimonial.plathform}</div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            {/* <div className={classes['carousel-dots']} >
									{testimonials.map((_, idx) => (
										<span
											key={idx}
											className={`${activeIndex === idx ? classes['active'] : ''}`}
										/>
									))}
								</div> */}
        </div>
    );
};

export default RegisterCarousel;